import React, {useState} from "react";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";
import CommonAttachments from "../../../common/attachment/Attachment";
import $ from "jquery";
import * as omnimap from "../../../../api/omnimap/omnimapActions";

class Detail extends React.Component {
  constructor(props) {
    super(props);
    this.rowId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.rowId;
    this.state = {
      rowData: this.props.history.location.state.rowData,
      media: null
    };
    window.$catalog_management_units_detail_context = this;
    //const [media, setMedia] = useState(null);
    this.setMedia = function (media) {
      window.$catalog_management_units_detail_context.setState({media: media})
    };

    this.handleModalAttachments = async () => {
      const spin = $("#cover-spin");
      spin.show(0);

      let result = await omnimap.GetMediaListAction(
          { path: "" },
          window.$catalog_management_units_selectedRow.identification,
          window.$catalog_management_units_token
      );
      await window.$catalog_management_units_detail_context.setMedia(result);
      spin.hide(0);

      $("#wp-catalogus-attachments").modal("show");
    };
  }



  render() {
    return (
      <div id="detailSide" /*className="d-none"*/>
        <div className="detail-title">Beheereenheid in detail</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a
              className="back-page-link"
              role="button"
              onClick={() => {
                this.props.history.push("/catalog/management-units/");
              }}
            >
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              beheereenheden
            </a>
          </div>
          <div className="float-right mt-0">
            <a
              id="edit-button"
              className="button bewerken"
              onClick={() => {
                this.props.history.push(
                  "/catalog/management-units/edit/" + this.rowId,
                  {
                    rowData: this.state.rowData,
                  }
                );
              }}
            >
              Bewerken
            </a>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Naam Beheereenheid</div>
              <div className="box-title-2-active" id="algemeenNaam">
                {this.state.rowData.algemeenNaam}
              </div>
              <span className="tooltiptext detail" id="algemeenNaam-tooltip">
                {this.state.rowData.algemeenNaam}
              </span>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Code Beheereenheid</div>
              <div className="box-title-2" id="algemeenCode">
                {this.state.rowData.algemeenCode}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Actief</div>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  checked={this.state.rowData.isActive ? true : false}
                  disabled
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-sm-6">
            <div className="inp-labl">Start horizon</div>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <img src={dateTimePng} width={30} height={28} />
                </span>
              </div>
              <input
                type="text"
                className="form-control inp-h inpp"
                id="startDate"
                disabled
                placeholder={this.state.rowData.startDate}
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="inp-labl">Eind horizon</div>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <img src={dateTimePng} width={30} height={28} />
                </span>
              </div>
              <input
                type="text"
                className="form-control inp-h inpp"
                id="endDate"
                disabled
                placeholder={this.state.rowData.endDate}
              />
            </div>
          </div>
          <div className="col-lg-2 text-center">
            <div className="box-detail">
              <div className="box-title-1">Bijlage(n)</div>
              <a role="button" onClick={() => this.handleModalAttachments()}>
                <div className="box-title-2 bijlage-ico" id="d-bijlage" />
              </a>
            </div>
          </div>
        </div>

        <CommonAttachments
            media={window.$catalog_management_units_detail_context.state.media}
            setMedia={window.$catalog_management_units_detail_context.setMedia}
            rowId={window.$catalog_management_units_selectedRow.identification}
            contextToReload={window.$catalog_management_units_context}
        />

      </div>
    );
  }
}

export default Detail;
